import {Component, OnInit, Output, EventEmitter, ViewChild} from '@angular/core';
import {GeocodingLocation} from './geocodingLocation';
import {AuthService} from '../../../services/auth/auth.service';
import {GoogleMap, MapGeocoder} from '@angular/google-maps';
import {Observable} from 'rxjs';
import {GoogleMapsService} from '../../../services/google/google-maps.service';

@Component({
  selector: 'app-google-geocoding',
  templateUrl: './google-geocoding.component.html',
  styleUrls: ['./google-geocoding.component.scss']
})
export class GoogleGeocodingComponent implements OnInit {

  apiLoaded: Observable<boolean>;
  @Output() addressSelected = new EventEmitter<GeocodingLocation>();
  @ViewChild(GoogleMap) map: GoogleMap;
  placesService: google.maps.places.PlacesService;

  options: google.maps.MapOptions = {
    zoom: 10,
    streetViewControl: false,
    mapTypeControl: false,
  };

  timezone: string;
  readonly coordinates: Record<string, {lat: number, lng: number}> = {
    'Europe/Tallinn': {lat: 59.436962, lng: 24.753574},
    'Europe/Riga': {lat: 56.946285, lng: 24.105078},
    'Europe/Vilnius': {lat: 54.687157, lng: 25.279652},
    'Europe/Minsk': {lat: 53.893009, lng: 27.567444}
  };

  constructor(private authService: AuthService, private geocoder: MapGeocoder, private googleMapsService: GoogleMapsService) {
    this.apiLoaded = this.googleMapsService.isApiLoaded$;
  }

  ngOnInit(): void {
    this.timezone = this.authService.user.timezone;
  }

  click(event: google.maps.MapMouseEvent) {
    this.geocode({location: event.latLng});
  }

  geocode(request: google.maps.GeocoderRequest): void {
    this.geocoder.geocode(request)
      .subscribe((res) => {
        if (res) {
          const geocoderResult = res.results[0];
          let geocodingLocation: GeocodingLocation = new GeocodingLocation();
          geocodingLocation.location = geocoderResult.formatted_address;

          if (this.placesService == null) {
            this.placesService = new google.maps.places.PlacesService(this.map.googleMap);
          }

          const placeRequest = {
            placeId: geocoderResult.place_id,
            fields: ["name", "website"]
          };

          this.placesService.getDetails(placeRequest, (results, status) => {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
              if (results.name) geocodingLocation.name = results.name;
              if (results.website) geocodingLocation.website = results.website;
            }
          });

          this.addressSelected.emit(geocodingLocation);
        }
      });
  }
}
